
<template>
  <b-card no-body class="wrapper" v-if="company != null && company.callbackDatetime">
    <template v-slot:header>
      <h4>Callback</h4>
    </template>
    <b-card-body>
      <b-card-text>
        <div class="label">Callback Date</div>
        <div class="text">{{ getDate() }}</div>

        <div class="label">Callback Time</div>
        <div class="text">{{ getTime() }}</div>

        <div class="label">Callback Type</div>
        <div class="text">{{ company.callbackType.name }}</div>

        <div class="label">Callback Agent</div>
        <div class="text">{{ company.callbackUser.firstName }} {{ company.callbackUser.lastName }}</div>

        <b-button variant="warning" block @click="clear" v-if="company.companyStatusId != 15">
          <font-awesome-icon icon="eraser" /> Clear Callback
        </b-button>

      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import { format } from 'date-fns'
import CompanyService from '@/services/Company.service';

export default {
  name: "Callback",
  props: {
    company: Object,
  },

  methods: {

    getDate() {
      return format(new Date(this.company.callbackDatetime), "dd/MM/yyyy")
    },

    getTime() {
      return format(new Date(this.company.callbackDatetime), "HH:mm")
    },

    clear() {
      CompanyService.clearCallback({companyId: this.company.id}).then(() => {
        this.$parent.loadData()
      })
    }
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
.wrapper {
  margin-top: 10px;
}
h4 {
  margin-bottom: 0;
}
</style>
